/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Typography, Skeleton, Tooltip } from '@mui/material';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { GetParticipantsResponse } from '@marageti/z4-sdk/lib/travel';
import { useAuthStore } from '../../store';

const ConversationParticipantNames = ({
  conversationId,
  typographyProps,
  skeletonProps,
  enableTooltip = false,
}: {
  conversationId: string | undefined
  typographyProps?: React.ComponentProps<typeof Typography>
  skeletonProps?: React.ComponentProps<typeof Skeleton>
  enableTooltip?: boolean
}) => {
  const apiClient = useApiClient();
  const { loggedInTeamMember } = useAuthStore();
  const {
    data: participants,
    error: participantsError,
    isLoading: isParticipantsLoading,
  } = useFetch<GetParticipantsResponse>(
    apiClient.conversationsClient.getParticipants,
    [conversationId, { params: { inactive: false } }],
    !!conversationId,
  );

  const names = participants
    ? Object.values(participants)
      .map((participant) => {
        if (participant.id === loggedInTeamMember?.id) {
          return 'You';
        }
        return `${participant.givenName} ${participant.familyName}`;
      })
      .sort((a, b) => {
        if (a === 'You') return -1;
        if (b === 'You') return 1;
        return 0;
      })
      .join(', ')
    : '';

  if (!conversationId || participantsError) {
    return null;
  }

  if (isParticipantsLoading) {
    return (
      <Typography {...typographyProps}>
        <Skeleton width="60%" {...skeletonProps} />
      </Typography>
    );
  }

  if (!participants) {
    return null;
  }

  return (
    <Tooltip title={names} disableHoverListener={!enableTooltip}>
      <Typography {...typographyProps}>
        {names}
      </Typography>
    </Tooltip>
  );
};

export default ConversationParticipantNames;
